var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffiBonus2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 71,
    viewBox: "0 0 61 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.893555 13.3728C1.27198 12.7673 5.69953 12.2375 5.69953 12.2375L11.6786 27.7528H8.61338L0.893555 13.3728Z",
    fill: "#404C29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13808 7.43164L10.3168 6.90186L15.804 23.0226L13.7983 27.8285L5.70007 9.77785C5.70007 9.77785 5.77575 7.62085 7.13808 7.43164Z",
    fill: "#404C29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6113 70.0981C34.6113 70.0981 29.0863 70.2873 23.1829 70.2495C17.0146 70.2116 10.4679 69.9467 9.67322 69.0007C8.76501 67.9411 11.2626 54.5829 10.2409 38.2729C9.25696 22.0009 1.87771 13.108 2.93729 11.0645C3.35356 10.232 5.05646 8.83183 7.13778 7.43167C6.0782 8.22635 7.0621 9.05888 8.91638 11.7457C10.8463 14.546 13.4196 22.1901 13.4196 22.1901C12.5871 14.054 9.33263 6.37209 10.5057 5.27467C10.5057 5.27467 10.5184 5.26206 10.5436 5.23683C12.7763 3.9502 14.8198 2.92847 15.8037 2.81494L33.4382 8.83183L34.6113 69.4926V70.0981Z",
    fill: "url(#paint0_linear_340_3503)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9393 59.3508C56.8131 60.1581 56.6744 60.915 56.523 61.6214C56.523 61.6466 56.5104 61.6718 56.4852 61.6971C55.7662 65.1028 54.8201 67.6004 53.647 68.6221C51.8684 70.2115 29.7685 70.7413 23.184 70.2494C22.3136 70.1737 21.7459 70.098 21.481 69.9845C21.3045 69.9088 21.1657 69.707 21.0648 69.379C19.7403 65.6705 21.9352 46.6738 19.6646 28.8502C17.167 9.43719 15.01 5.91788 15.1236 3.38246C15.1614 3.19325 15.3884 3.00404 15.8047 2.81483C20.6485 0.544304 50.9223 -1.57485 54.8579 1.64172C56.1824 2.73914 57.242 8.94524 57.8475 17.2326C57.8475 17.2579 57.8475 17.2831 57.8475 17.3083C57.9736 18.9482 58.0872 20.6637 58.1881 22.4548V22.5305C58.1881 22.5558 58.1881 22.5684 58.1881 22.5684C58.7936 34.867 58.5286 49.7768 56.9393 59.3508Z",
    fill: "url(#paint1_linear_340_3503)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3885 18.1029C20.6477 19.8437 22.8426 56.3234 23.1075 58.1398C23.4102 59.9562 27.5729 60.2968 32.9086 67.0327C36.0117 70.8926 46.3427 69.0383 47.7807 64.3081C49.2187 59.5778 54.3274 56.7397 55.7654 53.296C57.2034 49.8524 55.3869 17.3839 54.1003 15.5675C52.8137 13.7889 47.6293 10.3075 46.7967 3.64726C46.267 -0.250474 27.1188 1.83084 26.5511 2.81473C25.9835 3.79863 30.1461 10.4967 22.3885 18.1029Z",
    fill: "#D8EC38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6551 14.3566C23.6373 15.681 23.8644 53.7501 39.304 56.2099C54.7437 58.6696 57.3926 12.2374 36.6551 14.3566Z",
    fill: "url(#paint2_linear_340_3503)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9796 33.3532C36.466 31.6125 37.7904 30.3259 39.2663 29.9475C40.78 29.569 45.5481 34.2615 46.3806 34.2615C46.3806 34.2615 47.97 30.5529 47.8186 29.4177C47.7051 28.5851 45.4346 25.2929 42.3693 23.4008C42.3315 21.0924 42.2558 19.5409 42.1044 19.4274C41.5368 18.8219 37.1471 18.9733 36.2389 19.1625C36.0497 19.2003 36.0497 20.6762 36.1632 22.9845C33.0601 25.0658 31.1302 30.78 32.606 34.4507C34.536 39.1809 41.9152 37.2131 42.9748 38.4241C44.0344 39.6729 41.2719 42.7381 39.4933 42.6245C39.3924 42.5993 39.2789 42.5741 39.1528 42.5489C37.6391 41.9812 36.8065 38.689 35.8983 38.3106C34.8766 37.8943 32.3411 38.9917 31.9249 40.5054C31.5465 41.8299 35.4442 44.5923 38.4338 45.8411C38.6608 47.3926 38.8879 48.3765 39.0392 48.4144C39.0392 48.4144 41.499 48.9442 41.8396 48.4522C41.9152 48.3387 41.9909 47.317 42.0666 45.7276C44.602 44.2139 47.2888 40.2027 47.9322 38.1213C48.8025 35.321 39.4933 35.1318 37.9796 33.3532Z",
    fill: "#D8EC38"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5447 5.23682C10.5194 5.26204 10.5068 5.27466 10.5068 5.27466C10.4816 5.27466 10.4564 5.28727 10.4312 5.3125C10.4816 5.28727 10.5194 5.26204 10.5447 5.23682Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7176 70.1737C16.5227 69.4547 19.2473 55.9829 19.5501 51.6311C19.5501 51.6311 18.377 59.2752 16.5984 63.3621C14.8198 67.4491 14.3279 69.9845 15.9929 70.0602C17.658 70.1359 18.7176 70.1737 18.7176 70.1737Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6744 3.49604C15.0093 3.98799 20.2694 22.3414 22.994 29.4935C25.7187 36.6457 54.3274 30.9315 56.2952 27.9042C58.263 24.8768 56.106 6.40988 53.949 2.81488C51.792 -0.78011 23.9779 1.33905 16.6744 3.49604Z",
    fill: "white"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0.894121 13.3728C0.477856 14.2432 -0.127616 14.9243 0.0237533 15.5298C0.175122 16.1353 5.47304 20.1465 8.65179 32.1046C11.7927 44.0249 8.12199 67.5248 8.04631 68.3195C8.00847 69.1142 9.67353 69.0006 9.67353 69.0006C9.67353 69.0006 11.2629 47.9604 10.4304 35.5861C9.59785 23.2117 0.894121 13.3728 0.894121 13.3728Z",
    fill: "url(#paint3_linear_340_3503)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9702 29.7583C7.9702 29.7583 6.68355 30.4395 6.49434 30.7044C6.30513 31.0071 7.66746 35.1319 8.15941 41.1866C8.65136 47.2413 7.74314 50.6093 7.74314 51.631C7.74314 52.6528 18.6796 53.1825 20.723 53.2961C22.7665 53.4096 57.7328 52.9933 57.7328 52.9933C57.7328 52.9933 58.9816 52.7663 59.3222 51.9716C59.7006 51.1769 60.3061 29.5691 60.2682 28.5474C60.2304 27.5635 58.3761 27.2229 58.3761 27.2229L58.414 28.8501C58.414 28.8501 23.2963 31.4991 19.9662 31.5369C16.6739 31.5369 8.23509 30.7044 8.23509 30.7044L7.9702 29.7583Z",
    fill: "url(#paint4_linear_340_3503)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89441 39.635C7.89441 39.635 17.5063 40.4675 19.9282 40.6946C22.388 40.9217 60.0411 37.8564 60.0411 37.8564L59.8897 42.0191C59.8897 42.0191 22.7286 43.5706 20.0039 43.6463C17.2415 43.7598 8.65125 44.2896 8.65125 44.2896L7.89441 39.635Z",
    fill: "url(#paint5_linear_340_3503)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9667 31.5369C19.1342 32.2937 19.8532 33.9966 19.9667 42.1327C20.1181 50.2687 19.4748 52.0851 19.9667 52.6906C20.4965 53.2961 55.0844 53.1068 59.3227 51.9716C59.3227 51.9716 59.0578 52.9933 57.7333 52.9933L57.6198 54.1286C57.6198 54.1286 25.0376 55.7936 20.6857 55.4531C16.3717 55.1125 9.63578 53.3339 9.63578 53.3339V52.3122C9.63578 52.3122 7.70582 52.123 7.74367 51.631C7.78151 51.1391 8.68972 47.09 8.23561 42.4354C7.7815 37.743 6.45703 31.1585 6.45703 30.9314C6.49487 30.7044 7.97072 29.7583 7.97072 29.7583L8.19777 30.5151C8.19777 30.5151 15.3878 31.7639 19.9667 31.5369Z",
    fill: "#A42E89"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57019 31.537C7.21351 31.1207 17.8093 31.6883 18.7176 32.9371C19.6258 34.1859 19.8907 50.7986 19.4744 51.9717C19.0581 53.1826 8.7272 52.3501 8.23525 51.9717C7.7433 51.6311 9.14347 48.3388 8.50015 42.0192C7.81899 35.6617 6.57019 31.537 6.57019 31.537Z",
    fill: "#A42E89"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8636 31.6504C16.2581 31.6504 29.6543 33.3911 39.9474 32.2559C50.2026 31.1206 60.2687 28.9258 60.2687 28.9258L58.4144 28.8501C58.4144 28.8501 31.5464 31.8396 16.8636 31.6504Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 32.5209C20.1555 33.3534 24.2425 42.2085 27.2699 43.8357C30.3351 45.4629 44.3746 47.1279 50.3536 44.9709C56.3327 42.8139 59.1709 31.0072 59.3223 29.9476C59.4736 28.8881 47.2506 31.8398 39.4172 32.1803C31.5839 32.4831 22.8423 31.9911 21.8206 32.5209Z",
    fill: "#F0AE89"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1182 32.937C20.9885 32.1423 24.1294 40.0892 24.6971 44.2896C25.2647 48.4522 21.3291 51.9716 20.3831 51.9716C19.4748 51.9716 20.1182 32.937 20.1182 32.937Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8575 1.64172C56.182 2.73914 57.2416 8.94524 57.8471 17.2326C57.2416 11.6699 55.5009 3.49598 50.5057 1.37683C42.748 -1.91543 15.8043 2.81483 15.8043 2.81483C20.6481 0.544304 50.9219 -1.57485 54.8575 1.64172Z",
    fill: "#911D3D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9909 0.203653C32.3033 1.30107 40.1745 9.73985 46.9104 13.3727C53.6463 16.9677 55.4628 7.73422 53.495 3.76081C51.5272 -0.212609 41.9909 0.203653 41.9909 0.203653Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19719 30.5152C8.19719 30.5152 6.75918 24.0442 7.62955 19.9951C8.49993 15.9838 12.9275 21.925 14.3655 24.0063C15.8035 26.0876 11.3003 9.47498 12.6626 6.90172C14.0249 4.3663 20.1932 28.8123 19.8905 30.7044C19.5877 32.5965 8.19719 30.5152 8.19719 30.5152Z",
    fill: "#BE81A9"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.967 31.537C19.967 31.537 20.5346 27.1852 19.2101 19.9952C17.8856 12.8431 15.5394 6.10718 15.5394 6.10718C15.5394 6.10718 18.9074 17.7625 19.967 31.537Z",
    fill: "#BEEF31"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6852 55.4531C20.6852 55.4531 20.8366 69.3412 22.3125 70.1358C22.3125 70.1358 21.2907 70.2494 20.8366 69.3412C20.4204 68.3951 20.4204 58.5562 20.6852 55.4531Z",
    fill: "#BEE009"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4847 61.697C55.7657 65.1028 54.8197 67.6004 53.6466 68.6221C51.868 70.2115 29.7681 70.7413 23.1835 70.2493C17.0152 70.2115 10.4685 69.9466 9.67383 69.0005C9.67383 69.0005 15.6907 70.2115 21.0643 69.379C23.6755 68.9627 29.0491 69.3033 34.6119 69.4925C40.4396 69.7195 46.4943 69.7574 49.938 68.6221C54.1385 67.222 55.8414 63.9675 56.4847 61.697Z",
    fill: "#911D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_3503",
    x1: -52.7756,
    y1: 70.237,
    x2: -52.7756,
    y2: 2.80435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#636F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_340_3503",
    x1: -20.3956,
    y1: 70.4197,
    x2: -20.3956,
    y2: -0.00175453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84A61D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_340_3503",
    x1: 3.01255,
    y1: 56.3071,
    x2: 3.01255,
    y2: 14.2937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84A61D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_340_3503",
    x1: -139.696,
    y1: 69.0033,
    x2: -139.696,
    y2: 13.3637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#636F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_340_3503",
    x1: 6.46747,
    y1: 27.2119,
    x2: 60.2629,
    y2: 27.2119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_340_3503",
    x1: 7.90122,
    y1: 37.8659,
    x2: 60.0293,
    y2: 37.8659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiBonus2);
export default __webpack_public_path__ + "static/media/affi-bonus-2.3deed1d75348d83323c95ad9601f0678.svg";
export { ForwardRef as ReactComponent };